import { UserDisplayProfile } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useUserDisplayProfile(id?: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["userDisplayProfile", activeSessionId, id],

    queryFn: ({ signal }): Promise<UserDisplayProfile | null> => {
      if (!id) {
        return Promise.resolve(null);
      }
      return geotabClient
        .get("UserDisplayProfile", { user: { id }, getDefaultProfile: true }, 1, signal)
        .then(profiles => profiles[0] ?? null);
    },
  });
}
